import salon_1 from './salon_1.jpg'
import build_preview from './build_preview.png'
import hall from './hall.jpg'
import LeSecret_logo_1 from './LeSecret_logo_1.png'
import LeSecret_logo_2 from './LeSecret_logo_2.png'
import salon_2a from './salon_2a.jpg'
import steva_1 from './steva_1.png'
import room from './room.jpeg'
import salon_2a_2 from './salon_2a_2.jpg'
import interior1 from './interior1.png'
import facade from './facade.png'
import interior2 from './interior2.png'
import steva_logo from './steva_logo.png'
import valid from './valid.png'
import phone from './phone.png'

const Img = {
    salon_1,
    build_preview,
    hall,
    LeSecret_logo_1,
    LeSecret_logo_2,
    salon_2a,
    steva_1,
    room,
    salon_2a_2,
    interior1,
    facade,
    interior2,
    steva_logo,
    valid,
    phone
}

export default Img;